// extracted by mini-css-extract-plugin
export default {"wrapper":"_3-z","play":"a4-z"};